import { Spinner } from '@v2/ui/Icon/Spinner/Spinner';

interface Props {
  isLoading: boolean;
  onShowMoreClick: () => void;
}

export const ShowMoreButton = ({ isLoading, onShowMoreClick }: Props) => {
  return (
    <button
      disabled={isLoading}
      onClick={onShowMoreClick}
      className="flex w-full items-center justify-center rounded-b-lg bg-gray-75 py-3 text-sm font-semibold text-gray-800 md:py-4 md:text-base"
    >
      {isLoading ? <Spinner /> : 'Show More'}
    </button>
  );
};
